import { type Option, RadioGroupWithOptions, Title } from 'ui';
import type { ActivityOption } from './activity-types';

type P = {
  disabledEdit: boolean;
  isWithingsEnabled: boolean;
  onSelect: (type: ActivityOption) => void;
  selected: ActivityOption;
};

const ActivityFormStep2 = ({ disabledEdit, isWithingsEnabled, onSelect, selected }: P) => {
  const options: Array<Option<ActivityOption>> = [
    {
      description: '(e.g.: share your personal feedback to the webinar)',
      key: 'extended-feedback',
      title: 'Get extended feedback or response from the user',
    },
    {
      description: '(e.g.: record your blood sugar value)',
      key: 'numeric-feedback',
      title: 'Get numeric value from the user',
    },
    {
      description: '(e.g.: select which exercise you did and for how long)',
      key: 'select-feedback',
      title: 'Physical activity',
    },
  ];

  if (isWithingsEnabled) {
    options.push({
      key: 'withings-blood-pressure',
      title: 'Withings blood pressure',
    });
  }

  return (
    <div className="activity-form-step-2">
      <Title level={3} marginBottom>
        Select type of activity
      </Title>
      <RadioGroupWithOptions<ActivityOption>
        disabled={disabledEdit}
        onSelect={onSelect}
        options={options}
        selected={selected}
      />
    </div>
  );
};

export default ActivityFormStep2;
